import { render, staticRenderFns } from "./idle-banner.vue?vue&type=template&id=fbe5b00a&"
import script from "./idle-banner.vue?vue&type=script&lang=js&"
export * from "./idle-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports